(() => {
'use strict';
const items=[...document.querySelectorAll('[data-compact-nav]')];
if(!items.length)return;
const desktop=matchMedia('(width > 820px)'),fine=matchMedia('(hover:hover) and (pointer:fine)');
let active=null,timer;
function close(restore=false){
 clearTimeout(timer);if(!active)return;
 const item=active;active=null;item.querySelector('[data-compact-panel]').hidden=true;
 item.querySelector('[data-compact-toggle]').setAttribute('aria-expanded','false');
 if(restore)item.querySelector('[data-compact-toggle]').focus();
}
function position(item){
 if(!desktop.matches)return;
 const rect=item.getBoundingClientRect(),panel=item.querySelector('[data-compact-panel]');
 const bottom=document.querySelector('.primary-nav').getBoundingClientRect().bottom;
 const width=Math.min(370,innerWidth-24);
 panel.style.setProperty('--compact-left',Math.max(12,Math.min(rect.left,innerWidth-width-12))+'px');
 panel.style.setProperty('--compact-top',bottom+'px');
 panel.style.setProperty('--compact-height',Math.max(80,Math.min(420,innerHeight-bottom-12))+'px');
}
function open(item){
 // Navigation intent also dismisses in-flight search when hover leaves focus unchanged.
 item.dispatchEvent(new CustomEvent('smagtron:compact-nav-open',{bubbles:true}));
 clearTimeout(timer);if(active!==item)close();active=item;
 const panel=item.querySelector('[data-compact-panel]');position(item);panel.hidden=false;
 item.querySelector('[data-compact-toggle]').setAttribute('aria-expanded','true');
}
for(const item of items){
 const toggle=item.querySelector('[data-compact-toggle]'),panel=item.querySelector('[data-compact-panel]');
 toggle.addEventListener('click',()=>active===item?close():open(item));
 item.addEventListener('pointerenter',()=>{clearTimeout(timer);if(desktop.matches&&fine.matches)open(item)});
 item.addEventListener('pointerleave',()=>{if(desktop.matches&&fine.matches)timer=setTimeout(()=>{if(!item.contains(document.activeElement))close()},220)});
 panel.addEventListener('pointerenter',()=>clearTimeout(timer));
 item.addEventListener('focusout',()=>setTimeout(()=>{if(desktop.matches&&active===item&&!item.contains(document.activeElement))close()},0));
 item.addEventListener('keydown',event=>{
  if(event.key==='Escape'&&active===item){event.preventDefault();event.stopPropagation();close(true);return;}
  if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
  if(['Home','End'].includes(event.key)&&active!==item)return;
  event.preventDefault();const wasOpen=active===item;open(item);
  const links=[...panel.querySelectorAll('a')],index=links.indexOf(document.activeElement);
  const next=event.key==='Home'?0:event.key==='End'?links.length-1:event.key==='ArrowDown'?(index+1)%links.length:(index<=0?links.length-1:index-1);
  links[!wasOpen&&event.key==='ArrowDown'?0:next]?.focus();
 });
 panel.addEventListener('click',event=>{if(event.target.closest('a'))close()});
}
document.addEventListener('pointerdown',event=>{if(active&&!active.contains(event.target)&&(desktop.matches||!event.target.closest('[data-mobile-drawer]')))close()});
document.querySelector('form.search')?.addEventListener('focusin',()=>close());
document.querySelector('form.search')?.addEventListener('input',()=>close());
// Search fetches can complete after a pointer returns to navigation.
const search=document.querySelector('form.search');if(search)new MutationObserver(()=>{if(search.querySelector('[data-ux-suggestions]:not([hidden])'))close()}).observe(search,{subtree:true,attributes:true,attributeFilter:['hidden'],childList:true});
window.addEventListener('resize',()=>close());
window.addEventListener('scroll',()=>{if(active&&desktop.matches)position(active)},{passive:true});
document.querySelector('[data-menu-close]')?.addEventListener('click',()=>close());
document.querySelector('[data-menu-open]')?.addEventListener('click',()=>close());
// The document scroll root is HTML in this theme, not the body.
const drawer=document.querySelector('[data-mobile-drawer]');
if(drawer){
 const panel=drawer.querySelector('.drawer-panel');
 let scrollLock=null;
 const syncDrawer=()=>{
  const on=drawer.classList.contains('open');
  if(on&&!scrollLock){
   const root=document.scrollingElement||document.documentElement;
   scrollLock={root,hadStyle:root.hasAttribute('style'),overflow:['overflow-x','overflow-y'].map(key=>({key,value:root.style.getPropertyValue(key),priority:root.style.getPropertyPriority(key)})),x:scrollX,y:scrollY};
   root.style.setProperty('overflow','hidden','important');
   panel.scrollTop=0;
  }else if(!on&&scrollLock){
   const {root,hadStyle,overflow,x,y}=scrollLock;scrollLock=null;
   root.style.removeProperty('overflow');
   for(const {key,value,priority} of overflow){if(value)root.style.setProperty(key,value,priority);}
   if(!hadStyle&&!root.getAttribute('style'))root.removeAttribute('style');
   panel.scrollTop=0;window.scrollTo(x,y);
  }
 };
 new MutationObserver(syncDrawer).observe(drawer,{attributes:true,attributeFilter:['class']});
 syncDrawer();
 desktop.addEventListener('change',()=>{if(desktop.matches&&drawer.classList.contains('open'))document.querySelector('[data-menu-close]')?.click();});
}
})();
